<template>
  <div>
    <v-dialog v-model="dialog" absolute fullscreen>
      <v-card>
        <v-card-title class="headline grey lighten-3" v-text="$t('labels.tos')"></v-card-title>
        <v-card-text class="pa-0 ma-0">
          <embed class="emb-gdrp-pp" src="https://www.hgstudio.ru/HGS-GDPR-and-privacy-policy.pdf" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            text
            @click="agreement = false, dialog = false"
            v-text="$t('no')"
          ></v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            color="deep-purple accent-4"
            @click="agreement = true, dialog = false"
            v-text="$t('yes')"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-form @submit.prevent="signup" ref="form" lazy-validation v-model="valid">
      <v-text-field
        v-model="email"
        name="email"
        :label="$t('labels.email')"
        :rules="emailRules"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        :type="show ? 'text' : 'password'"
        name="password"
        :label="$t('labels.password')"
        @click:append="show = !show"
        :rules="passwordRules"
        required
      ></v-text-field>
      <v-checkbox
        v-model="promo"
        color="deep-purple"
        :label="$t('labels.promo')"
      >
      </v-checkbox>
      <v-checkbox
        v-model="agreement"
        class="mt-0"
        color="deep-purple"
        :rules="[v => !!v || $t('validations.agreement_invalid')]"
      >
        <template v-slot:label>
          <div>{{$t('labels.agree_to')}}&nbsp;<a href="#" @click.stop.prevent="dialog = true" v-text="$t('labels.agree_to_tos')"></a></div>
        </template>
      </v-checkbox>

      <v-row align="center" justify="center" class="mt-1">
        <v-btn x-large color="primary" type="submit" :disabled="!valid" v-text="$t('play')"></v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'signup',
  data () {
    return {
      valid: true,
      dialog: null,
      agreement: false,
      promo: false,
      email: null,
      emailRules: [
        v => !!v || this.$t('validations.email_required'),
        v => /.+@.+\..+/.test(v) || this.$t('validations.email_invalid')
      ],
      password: null,
      passwordRules: [
        v => !!v || this.$t('validations.password_required'),
        v => (v && v.length >= 6) || this.$t('validations.password_invalid')
      ],
      show: false
    }
  },
  methods: {
    signup () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$store.dispatch('auth/process', {
        type: 'signup',
        callback: document.location.origin + this.$router.resolve({ name: 'auth' }).href,
        payload: {
          accept_consent: this.agreement,
          email: this.email,
          password: this.password,
          promo_email_agreement: (this.promo ? 1 : 0),
          username: this.email
        }
      }).then((res) => {
        if (res.status === 204) {
          this.$store.dispatch('addInfo', this.$t('notifications.check_email'))
        }

        this.dialog = null
        this.agreement = false
        this.promo = false
        this.email = null
        this.password = null
        this.show = false
        this.$router.push({ name: 'home' })
      }).catch((e) => {
        this.$store.dispatch('addError', e.message)
      })
    }
  }
}
</script>

<style>
.emb-gdrp-pp {
  width: 100%;
  min-height: calc(100vh - 110px);
}
</style>
